import React from 'react';
import GoogleMapReact from 'google-map-react';
import styled from 'styled-components';
import { LocationIcon } from 'assets/svgs';

const isClient = typeof window !== 'undefined';

function Map() {
  /* eslint-disable react/no-unknown-property */
  return (
    <Container>
      <InnerContainer className="map">
        {isClient && (
          <GoogleMapReact
            bootstrapURLKeys={{ key: process.env.GATSBY_MAP_API }}
            defaultCenter={[53.328639184566775, -6.350193340481675]}
            defaultZoom={16}>
            <div className="marker" lat={53.328639184566775} lng={-6.350193340481675}>
              <Marker>
                <LocationIcon />
                <p>Connolly Stairs</p>
              </Marker>
            </div>
          </GoogleMapReact>
        )}
      </InnerContainer>
    </Container>
  );
}

const Container = styled.section`
  background-color: var(--connolly-grey);
  display: grid;
  grid-column-gap: 1.25rem;
  grid-template-columns: repeat(12, 1fr);
  margin: 0 auto;
  max-width: 90rem;
  padding: 0;

  @media (width >= 590px) {
    padding: 0 0.625rem;
  }
`;

const InnerContainer = styled.div`
  background-color: #fff;
  border-radius: 0.375rem;
  grid-column: 1/-1;
  margin: 0 auto;
  max-width: 590px;
  min-height: 446px;
  position: relative;
  top: 0;
  width: 100%;
  z-index: 1;

  @media (width >= 900px) {
    grid-column: 2/12;
    max-width: initial;
  }
`;

const Marker = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  height: 30px;
  width: 220px;

  p {
    color: var(--connolly-red);
    font-size: 0.75rem;
    font-weight: 700;
  }

  svg {
    height: 30px;
    width: 30px;

    path {
      fill: var(--connolly-red);
    }
  }
`;

export default Map;
